<div class="raw-content-page-layout">
  <div class="blog-content-wrapper">
    <app-blog-card
        [date]="blog.date"
        [src]="'./assets/blog/' + blog.url"></app-blog-card>
  </div>

  <oth-button [buttonClasses]="['lighter-contrast-border-color', 'lighter-contrast-font-color', 'transparent-button']" [icon]="'chevron-left'" [routerLink]="URLS.blog"
              [text]="'Back'">
  </oth-button>

  <oth-hero [contents]="[{ text: 'About the Author', level: 2 }]"></oth-hero>
  <div class="employees-wrapper">
    <app-employee-card [employee]="blog.author"></app-employee-card>
  </div>
</div>
